import { AUTOMATION_ACTIONS, OBJECT_REVOKE_ACCESS_TYPES } from '../../../../../constants'

export enum ReassignMode {
  DATASOURCE_OWNER = 'DATASOURCE_OWNER',
  MANAGER = 'MANAGER',
  SPECIFIC_USER = 'SPECIFIC_USER'
}

export enum DisableAccountMode {
  DISABLE_ACCOUNT = 'DISABLE_ACCOUNT'
}

export enum AutomationTriggerField {
  GENERATED_AT = 'GENERATED_AT'
}

export enum FrequencyType {
  IMMEDIATELY = 'IMMEDIATELY',
  DAYS = 'DAYS'
}

export interface ActionDelay {
  type: FrequencyType
  value?: number
}

export interface BaseAutomationConfiguration {
  datasourceId: string
  status: boolean
  id?: string
}

export interface RevokeAccessConfig extends BaseAutomationConfiguration {
  revokeAction: OBJECT_REVOKE_ACCESS_TYPES
  duration: number
}

export type RedactionConfig = BaseAutomationConfiguration

export interface AccessPatternConfig extends BaseAutomationConfiguration {
  consecutiveAccessPatternCount: number
}

export interface ReassignObjectsConfig extends BaseAutomationConfiguration {
  reassignMode: ReassignMode
  user?: string
  automationTriggersubAlertField: AutomationTriggerField
  reassignObjectsActionFrequency: ActionDelay
}

export interface DisableAccountConfig extends BaseAutomationConfiguration {
  disableAccountActionFrequency: ActionDelay
  disableAccountMode: DisableAccountMode
}

export interface ArchiveObjectConfig extends BaseAutomationConfiguration {
  duration: number
}

export interface DeleteObjectConfig extends BaseAutomationConfiguration {
  duration: number
  deleteConfirmText?: string
}
export interface RevokeAccessAutomationConfig {
  action: AUTOMATION_ACTIONS.REVOKE_ACCESS
  configuration: RevokeAccessConfig[]
  enabled?: boolean
}

export interface RedactionAutomationConfig {
  action: AUTOMATION_ACTIONS.REDACTION
  configuration: RedactionConfig[]
  enabled?: boolean
}

export interface AccessPatternAutomationConfig {
  action: AUTOMATION_ACTIONS.DISABLE_ACCOUNT
  configuration: AccessPatternConfig[]
  enabled?: boolean
}

export interface ReassignObjectsAutomationConfig {
  action: AUTOMATION_ACTIONS.REASSIGN_OBJECTS
  configuration: ReassignObjectsConfig[]
  enabled?: boolean
}

export interface DisableAccountAutomationConfig {
  action: AUTOMATION_ACTIONS.DISABLE_ACCOUNT
  configuration: DisableAccountConfig[]
  enabled?: boolean
}

export interface ArchiveObjectAutomationConfig {
  action: AUTOMATION_ACTIONS.ARCHIVE_OBJECT
  configuration: ArchiveObjectConfig[]
  enabled?: boolean
}

export interface DeleteObjectAutomationConfig {
  action: AUTOMATION_ACTIONS.DELETE_OBJECT
  configuration: DeleteObjectConfig[]
  enabled?: boolean
}

export type AutomationConfig =
  | RevokeAccessAutomationConfig
  | RedactionAutomationConfig
  | AccessPatternAutomationConfig
  | ReassignObjectsAutomationConfig
  | DisableAccountAutomationConfig
  | ArchiveObjectAutomationConfig
  | DeleteObjectAutomationConfig

export interface AutomationConfigProps {
  datasourceId?: string
}

export interface RedactionAutomationConfigProps extends AutomationConfigProps {
  configuration: RedactionConfig
  onChange: ({ key, value }: { key: keyof RedactionConfig; value: any }) => void
}

export interface RevokeAccessAutomationConfigProps extends AutomationConfigProps {
  configuration: RevokeAccessConfig
  onChange: ({ key, value }: { key: keyof RevokeAccessConfig; value: any }) => void
}

export interface AccessPatternAutomationConfigProps extends AutomationConfigProps {
  configuration: AccessPatternConfig
  onChange: ({ key, value }: { key: keyof AccessPatternConfig; value: any }) => void
}

export interface ReassignObjectsUsersAutomationProps extends AutomationConfigProps {
  configuration: ReassignObjectsConfig
  onChange: ({ key, value }: { key: keyof ReassignObjectsConfig; value: any }) => void
  activeDirectoryId: string
}

export interface DisableAccountUsersAutomationProps extends AutomationConfigProps {
  configuration: DisableAccountConfig
  onChange: ({ key, value }: { key: keyof DisableAccountConfig; value: any }) => void
  activeDirectoryId: string
}

export interface ArchiveObjectAutomationConfigProps extends AutomationConfigProps {
  configuration: ArchiveObjectConfig
  archiveLocation?: string
  onArchiveLocationBlur: (value: string) => void
  onChange: ({ key, value }: { key: keyof ArchiveObjectConfig; value: any }) => void
}

export interface DeleteObjectAutomationConfigProps extends AutomationConfigProps {
  configuration: DeleteObjectConfig
  onChange: ({ key, value }: { key: keyof DeleteObjectConfig; value: any }) => void
}
